import { Injectable } from "@angular/core";
import { SnackBarModel } from "./snack-bar.model";
import { MaterialSnackBar } from "../infrastructure/snack-bar";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
  useClass: MaterialSnackBar,
})
export abstract class SnackBarImp {
  public abstract open(config: SnackBarModel): Observable<void>;

  public abstract close(): void;
}
